<template>
  <div class="numeric-entry-holder">
    <div class="numeric-entry">{{ entry }}</div>
    <div class="buttons">
      <NumericEntryButton
        v-for="(value,index) in values"
        :key="index"
        :value="value"
        @mouseenter="handleMouseEnter"
        @mouseleave="handleMouseLeave"
        @click="handleNEButtonClick($event, value)"
      />
    </div>
  </div>
</template>

<script>
import { useInputStore } from '@/store/InputStore';
import { useSettingsStore } from '@/store/SettingsStore';
import NumericEntryButton from '@/components/nelson/numeric_entry/NumericEntryButton';
import * as UnitConversion from '@/services/UnitConversionService';

export default {
  name: 'NumericEntry',
  props: [
    'segment'
  ],
  emits: [
    'hide'
  ],
  data () {
    return {
      values: [1,2,3,4,5,6,7,8,9,'.',0,'ENTER'],
      entry: '0'
    };
  },
  components: { NumericEntryButton },
  methods: {
    handleNEButtonClick (e, num) {
      e.preventDefault();
      e.stopImmediatePropagation();
      if (num !== 'ENTER') {
        if (this.entry === '0' && num !== 0) {
          this.entry = '';
        }
        this.entry += num;
      } else {
        // ENTER
        this.$props.segment.value = UnitConversion.UnfilterLength(this.entry, useSettingsStore().getLengthUnit);
        useInputStore().sprinklerCalc();
        this.entry = '0';
        this.$emit('hide');
      }
    },
    handleMouseEnter () {
      document.body.addEventListener('mousedown', this.handleMouseDown);
    },
    handleMouseLeave () {
      // document.body.removeEventListener('mousedown', this.handleMouseDown);
    },
    handleMouseDown (e) {
      if (!e.target.classList.contains('numeric-entry-button-holder')) {
        this.$emit('hide');
      }
      this.handleMouseLeave();
    }
  }
};
</script>

<style scoped>
.numeric-entry-holder {
  width: 200px;
  height: 250px;
  background-color: white;
  border: 1px black solid;
  position: absolute;
  margin-top: -230px;
  margin-left: 50px;
  display:flex;
  flex-direction: column;
}
.buttons {
  display:flex;
  flex-wrap: wrap;
  flex: 1;
}
.numeric-entry {
  background-color: whitesmoke;
  height: 25px;
  margin: 17px;
  border-radius: 10px;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding-right: 10px;
}
</style>